import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Text } from '@lightspeed/flame/Text';
import { Button } from '@lightspeed/flame/Button';
import { IconDevices } from '@lightspeed/flame/Icon/Devices';
import { IconUsbPlug } from '@lightspeed/flame/Icon/UsbPlug';
import { IconContent } from '@lightspeed/flame/Icon/Content';
import Client from 'pages/views/devices/socketClient';
import { STATUS } from 'pages/views/devices/socketClient/types';
import { setHubEnabled } from 'pages/views/devices/utils/storage';
import { PROTOCOL, PROTOCOL_IFRAME, APP_NAME } from 'pages/views/devices/utils/helper';
import { OptionFlex, IconBox, TextBox, ButtonBox, StyledModalBody } from '../../device.styles';
import { DownloadHub } from '../../components/DownloadHub';

interface ConnectionSelectorProps {
  url: string;
  handleClick: () => void;
}

const LinkButton = styled(Button)`
  color: white !important;
`;

const ConnectionSelector: React.FC<ConnectionSelectorProps> = ({ url, handleClick }) => {
  const hubConnectionStatus = useSelector(state => state.hub.connection.hub);
  const isHubConnected = hubConnectionStatus === STATUS.CONNECTED;

  return (
    <>
      <StyledModalBody data-test="connection-selector-modal">
        <OptionFlex>
          <IconBox>
            <IconUsbPlug />
          </IconBox>
          <TextBox>
            <Text fontWeight="bold">Connect using {APP_NAME} (Recommended)</Text>
          </TextBox>
          <ButtonBox>
            {isHubConnected ? (
              <LinkButton
                color="white"
                width="100%"
                href={`${PROTOCOL}${Client.getCFDParams()}&routeTo=cfd`}
                target={PROTOCOL_IFRAME}
                variant="secondary"
                fill
                mb={1}
              >
                Open Hub
              </LinkButton>
            ) : (
              <DownloadHub isButton content="Download Hub" width="100%" />
            )}
          </ButtonBox>
        </OptionFlex>
      </StyledModalBody>
      <StyledModalBody>
        <OptionFlex>
          <IconBox>
            <IconContent />
          </IconBox>
          <TextBox>
            <Text fontWeight="bold">Open in browser window</Text>
          </TextBox>
          <ButtonBox>
            <Button
              fill
              width="100%"
              onClick={() => {
                window.open(url, 'cfdwindow', 'chrome=yes');
                setHubEnabled();
                Client.connect();
              }}
            >
              Use browser
            </Button>
          </ButtonBox>
        </OptionFlex>
      </StyledModalBody>
      <StyledModalBody>
        <OptionFlex>
          <IconBox>
            <IconDevices />
          </IconBox>
          <TextBox>
            <Text fontWeight="bold">Connect using phone or tablet as display</Text>
          </TextBox>
          <ButtonBox>
            <Button fill onClick={handleClick} width="100%">
              Use device
            </Button>
          </ButtonBox>
        </OptionFlex>
      </StyledModalBody>
    </>
  );
};

export { ConnectionSelector };
